import { CardContent } from '@cfa/react-components';

interface PlanCardContentProps {
  children: React.ReactNode;
}

const PlanCardContent: React.FC<PlanCardContentProps> = ({ children }) => (
  <CardContent className="flex! w-full! max-w-full! grow! flex-col! items-start! justify-center! overflow-hidden! p-0!">
    {children}
  </CardContent>
);

export default PlanCardContent;
